import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { TimePickerComponent } from '@syncfusion/ej2-react-calendars'
import axios from 'axios';
import Select from 'react-select';
import $ from 'jquery';
const ViewShift = (props) => {

    const [items, setitems] = useState([]);
    const [addunit, setunit] = useState([])
    const [typevaluecom, settypevaluecom] = useState();
    const [typecom, settypecom] = useState([])
    const [unitvalue, setunitvalue] = useState()
    const url = process.env.REACT_APP_APIURL + "Shift/GetShiftsuper"//?companyid="+props.companyid;
    useEffect(() => {
        setTimeout(() => {
            $('#example3').DataTable().destroy()
            populatedata()
        }, 100)

    }, []);
    useEffect(() => {
        fetchCompany()
    }, []);
    async function fetchCompany() {

        var res = await axios.get(process.env.REACT_APP_APIURL + "Company/GetCompanies")

        var type = [];
        res.data.map((u) => {
            type.push({ value: u.company_id, label: u.name });
        })
        settypecom(type)
    }
    useEffect(() => {
       
        $('#example3').DataTable();
    }, [items]);

    useEffect(() => {
        //fetchUnitdata()
    }, []);

    async function fetchUnitdata() {
        const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/GetFramUnits?companyid=" + props.companyid;
        let Unitdata = await axios.get(Uniturl);
        var units = [];
        Unitdata.data.map((u) => {
            units.push({ value: u.unitId, label: u.unitName });
        })
        setunit(units);
    }
    async function populatedata() {
        await fetch(url).then(res => res.json()).then(result =>
           
            setitems(result)
        );
    }
    async function deletedata(id) {
        const urldelete = process.env.REACT_APP_APIURL + 'Shift/DeleteShift?shiftid=' + id 
         let res = await axios.post(urldelete)
         if (res.status == 200) {
             swal({
                 title: "Deleted Successfully",
                 icon: "success"
             })
             populatedata();

         }
    }

    async function handleEdit(id) {
        const newurl = process.env.REACT_APP_APIURL + "Shift/GetShift?shiftid=" + id +"&companyid=" + props.companyid;
        await fetch(newurl).then(res => res.json()).then(result => {
            debugger;
            //setupdateitems({ ...updateitems, ShiftId: result.shiftId, ShiftName: result.shiftName, Slot: result.slot, CheckInTime: result.checkInTime, CheckOutTime: result.checkOutTime, type: result.type, UnitId: result.unitId, UnitName: result.unitName, Amount: result.amount, company_id: props.companyid })
            setupdateitems({ ...updateitems, ShiftId: result.shiftId, ShiftName: result.shiftName, desciption: result.desciption, type: result.type, company_id: result.company_id })
            settypevaluecom({ value: result.Company_id, label: result.companyName })
            setunitvalue({ value: result.unitId, label: result.unitName })
            if (result.type == "1") {
                settypevalue({ ...typevalue, value: result.type, label: "Morninig" })
            }
            if (result.type == "2") {
                settypevalue({ ...typevalue, value: result.type, label: "Evening" })
            }
            if (result.type == "3") {
                settypevalue({ ...typevalue, value: result.type, label: "Full" })
            }
            if (result.type == "4") {
                settypevalue({ ...typevalue, value: result.type, label: "Full-Night" })
            }
        });
        $("#myModal").modal("show")
    }
    function handleDelete(id) {
        swal({
            title: "Are you sure?",
            //  text: "Once deleted, you will not be able to recover this imaginary file!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete)
            {
                deletedata(id);
              
            } else {
                swal("0 Rows deleted");
            }
        });
    }
    /////////////////////////////////////////////////////
   ////////////////UPDATE SHIFT/////////////////////////
  /////////////////////////////////////////////////////
    //const [updateitems, setupdateitems] = useState({ ShiftId: "", ShiftName: "", Slot: "", CheckInTime: "", CheckOutTime: "", type: "", UnitId: "", Amount: "", company_id: props.companyid })
    const [updateitems, setupdateitems] = useState({ ShiftId: "", ShiftName: "", desciption: "", type: "", company_id: "", usertypeid:"" })
    const [typevalue, settypevalue] = useState()
    const [type, settype] = useState([
        { label: "Morning 12 hours", value: "1" },
        { label: "Night 12 Hours", value: "2" },
        { label: "Morning 24 hours", value: "3" },
        { label: "Night 24 Hours", value: "4" }

    ])
    useEffect(() => {

    }, []);
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setupdateitems({ ...updateitems, [name]: value })
    }
    const handletime = e => {
        if (e.value) {
            const name = e.target.name;
            setupdateitems({ ...updateitems, [name]: e.value.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) })
        }
    }
    const refresh = () => {
        //setupdateitems({ ...updateitems, ShiftId: "", ShiftName: "", Slot: "", CheckInTime: "", CheckOutTime: "", type: "", UnitId: "", Amount: "", company_id: props.companyid });
        setupdateitems({ ...updateitems, ShiftId: "", ShiftName: "", desciption: "", type: "", company_id: "" });
        settypevalue(null)
        setunitvalue(null)
        settypevaluecom(null)
    }
    const savemethod = async (data) => {
        debugger;
        //data.companyid = typevaluecom.value;
        //data.company_id = typevaluecom.value;
        const url = process.env.REACT_APP_APIURL + "Shift/UpdateShift";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    icon: "success"
                })
                refresh();
                populatedata();
                $("#myModal").modal("hide");
            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (items.CheckInTime == "") {
            swal({
                title: "CheckInTime Required!",
                icon: "error"
            })
            return;
        }
        if (items.CheckOutTime == "") {
            swal({
                title: "CheckOutTime Required!",
                icon: "error"
            })
            return;
        }
        if (items.type == "") {
            swal({
                title: "Type Required!",
                icon: "error"
            })
            return;
        }
        savemethod(updateitems);
        // console.log(items);
    }
    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-0">View Shift List</h3>
                    </div>
                    <div className="card-body">

                        <div className="table-responsive">
                            <table id="example3" className="display" data-page-length='50'>
                                <thead>
                                    <tr>
                                        <th>Shift Name</th>
                                        <th>Desciption</th>
                                        <th>Company Name</th>
                                        {/*<th>Slot</th>*/}
                                        {/*<th>Unit Name</th>*/}
                                        {/*<th>CheckIn Time</th>*/}
                                        {/*<th>CheckOut Time</th>*/}
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map(item =>
                                       
                                        <tr key={item.shiftId}>
                                            <td>{item.shiftName}</td>
                                            <td>{item.desciption}</td>
                                            <td>{item.companyName}</td>
                                            {/*<td>{item.slot}</td>*/}
                                            {/*<td>{item.UnitName}</td>*/}
                                            {/*<td>{item.checkInTime}</td>*/}
                                            {/*<td>{item.checkOutTime}</td>*/}
                                            <td>
                                                <span className="d-flex">
                                                    <button href="#" className="btn btn-primary shadow btn-xs sharp me-2"
                                                        onClick={(id) => handleEdit(item.shiftId)}>
                                                        <i className="fas fa-pencil-alt"></i>
                                                    </button>
                                                    <button href="#" className="btn btn-danger shadow btn-xs sharp"
                                                        onClick={(id) => handleDelete(item.shiftId)}>
                                                        <i className="fa fa-trash"></i>
                                                    </button>
                                                </span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id="myModal" className="modal fade " tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="me-auto mb-5 mt-5 text-center mx-auto">Update Shift</h3>
                            </div>
                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row flex-column align-items-center">
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label htmlFor="shift_name" className="form-label">Shift Name</label>
                                                <input type="text" className="form-control" name="ShiftName" value={updateitems.ShiftName} onChange={handleInput} required />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label htmlFor="desciption" className="form-label">Desciption</label>
                                                <input type="text" className="form-control" name="desciption" value={updateitems.desciption} onChange={handleInput} required />
                                            </div>
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label className="form-label">Comapany Name *</label>
                                                <Select options={typecom} value={typevaluecom} onChange={(e) => { settypevaluecom(e); setupdateitems({ ...updateitems, company_id: e.value }) }} />
                                            </div>
                                            {/*<div className="mb-3 col-6">*/}
                                            {/*    <label htmlFor="shift_name" className="form-label">Slot</label>*/}
                                            {/*    <input type="text" className="form-control" name="Slot" value={updateitems.Slot} onChange={handleInput} required />*/}
                                            {/*</div>*/}
                                            {/*<div className="mb-3 col-sm-6">*/}
                                            {/*    <label htmlFor="timepicker">CheckIn Time</label>*/}
                                            {/*    <TimePickerComponent name="CheckInTime" className="form-control" value={updateitems.CheckInTime} onChange={handletime} required />*/}
                                            {/*</div>*/}
                                            {/*<div className="mb-3 col-sm-6">*/}
                                            {/*    <label htmlFor="timepicker2">CheckOut Time</label>*/}
                                            {/*    <TimePickerComponent name="CheckOutTime" className="form-control" value={updateitems.CheckOutTime} onChange={handletime} required />*/}
                                            {/*</div>*/}
                                            {/*<div className="mb-3 col-sm-6">*/}
                                            {/*    <label htmlFor="unit_name" className="form-label">Unit</label>*/}
                                            {/*    <Select name="unit" value={unitvalue} options={addunit} onChange={(e) => { setunitvalue(e); setupdateitems({ ...updateitems, UnitId: e.value }) }} />*/}
                                            {/*</div>*/}
                                            {/*<div className="mb-3 col-6">*/}
                                            {/*    <label htmlFor="amount_name" className="form-label">Amount</label>*/}
                                            {/*    <input type="text" className="form-control" name="Amount" value={updateitems.Amount} onChange={handleInput} required />*/}
                                            {/*</div>*/}
                                            <div className="mb-3 col-sm-12 col-lg-12">
                                                <label htmlFor="timepicker2">Type</label>
                                                <Select value={typevalue} options={type} onChange={(e) => { settypevalue(e); setupdateitems({ ...updateitems, type: e.value }) }} />
                                            </div>
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                            <input type="submit" className="btn btn-primary" value="Save" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ViewShift;